module.exports = __webpack_public_path__ + "assets/measure_expenses_by_type.782cc84d.svg";